import type { ComponentStatus } from '../../types';

import useTranslate from 'app/i18n/useTranslate';

const useTranslation = (): Record<ComponentStatus, string> => {
    const t = useTranslate('componentStatusRow');

    return {
        COMPLIANT: t('compliant'),
        DUE: t('due'),
        NOT_REPORTED: t('notReported'),
        OK: t('ok'),
        OUTDATED: t('outdated')
    };
};

export default useTranslation;
